module.exports = __webpack_public_path__ + "img/IMG_6445 1.0783355a.webp";